import type { FunctionComponent } from 'react';

import { ProgressCircleOutline } from './ProgressCircleOutline';

const radius = 5.2;
const strokeWidth = 1.5;
const circleLength = Math.PI * radius * 2;
const arrowPath = 'M5.6 6.5L7 4.875M7 4.875L8.4 6.5M7 4.875V9.125';

export const PublishProgressIcon: FunctionComponent<{
    readonly colorBase: string;
    readonly colorFill: string;
    readonly progress: number;
}> = ({ colorBase, colorFill, progress }) => {
    const dashLength = circleLength * progress;

    return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
        <svg fill="none" height="14" viewBox="0 0 14 14" width="14" xmlns="http://www.w3.org/2000/svg">
            <circle
                className="in-data-[is-active=true]:!stroke-text-on-accent"
                cx="7"
                cy="7"
                r={radius}
                stroke={colorBase}
                strokeWidth={strokeWidth}
            />
            <ProgressCircleOutline
                circleLength={circleLength}
                cx="7"
                cy="7"
                dashLength={dashLength}
                radius={radius}
                strokeWidth={strokeWidth}
                transform="rotate(-90 7 7)"
            />
            <circle
                className="in-data-[is-active=true]:!stroke-text-on-accent"
                cx="7"
                cy="7"
                r={radius}
                stroke={colorFill}
                strokeDasharray={`${dashLength} ${circleLength}`}
                strokeLinecap="round"
                strokeWidth={strokeWidth}
                transform="rotate(-90 7 7)"
            />
            <path
                className="in-data-[is-active=true]:!stroke-text-on-accent"
                d={arrowPath}
                stroke={progress > 0.5 ? colorFill : colorBase}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
